import { Outlet } from 'react-router'
import { useAuth } from '@/lib/auth'
import { AppShell } from '@/components/shell'
import { TerminologyProvider } from '@/lib/terminology'

export function AppLayout() {
  const { user, profile, membership, signOut } = useAuth()

  const userData = profile
    ? {
        name: profile.name,
        email: profile.email,
        avatarUrl: profile.avatar_url ?? undefined,
      }
    : {
        name: user?.email?.split('@')[0] || 'User',
        email: user?.email,
      }

  const teamName = membership?.teams?.name ?? 'My Team'

  return (
    <TerminologyProvider>
      <AppShell user={userData} teamName={teamName} onLogout={signOut}>
        <Outlet />
      </AppShell>
    </TerminologyProvider>
  )
}
